export default function ChartSourceList({ sources = [] }) {
  return (
    <section className="soft-card p-6 sm:p-8">
      <h2 className="text-2xl font-black text-neutral-950">Sources</h2>
      {sources.length ? (
        <ul className="mt-5 grid gap-3">
          {sources.map((source) => (
            <li key={source.url} className="rounded-2xl border border-neutral-200 bg-neutral-50 px-4 py-3">
              <a href={source.url} target="_blank" rel="noreferrer" className="font-bold text-blue-700 hover:underline">{source.name}</a>
            </li>
          ))}
        </ul>
      ) : <p className="mt-4 text-neutral-600">No verified source records are available for this dataset yet.</p>}
    </section>
  );
}
